import { readMetadata as readMetadata$1 } from '../engine-assemblyscript/run/metadata.js';
import { createEngine } from '../engine-javascript/run/index.js';

const readMetadata = async (target, compiled) => {
    switch (target) {
        case 'assemblyscript':
            return readMetadata$1(compiled);
        case 'javascript':
            return createEngine(compiled).metadata;
    }
};

export { readMetadata };
